import React from "react";
import { StyleSheet, Text, View } from "react-native";

import { DEV_COLOR } from "./devStyles";

/** Dashed magenta ring + "dev" tag on the word button of the next best move. */
const DevChipRing: React.FC = () => (
  <View pointerEvents="none" style={styles.ring} testID="dev-optimal-chip">
    <Text style={styles.tag}>dev</Text>
  </View>
);

const styles = StyleSheet.create({
  ring: {
    position: "absolute",
    top: -3,
    left: -3,
    right: -3,
    bottom: -3,
    borderRadius: 12,
    borderWidth: 2,
    borderStyle: "dashed",
    borderColor: DEV_COLOR,
  },
  tag: {
    position: "absolute",
    top: -7,
    right: 6,
    paddingHorizontal: 2,
    fontSize: 8,
    fontWeight: "700",
    color: DEV_COLOR,
    backgroundColor: "#121212",
  },
});

export default DevChipRing;
